import thxToYouPinUrl from './thx-to-you/qmusic-pin.webp'
import ThxToYouSleepingOverlay from './thx-to-you/SleepingOverlay.ce.vue'
import { applyMapTheme as applyThxToYouMapTheme, BELGIUM_BOUNDS } from './thx-to-you/mapTheme.js'

export const defaultCampaignId = 'thx-to-you'

const campaigns = {
  'thx-to-you': {
    id: 'thx-to-you',
    title: 'Thx to You',
    dario: {
      stationId: 'qmusic_be',
      trackers: [{ uuid: '6425c76c-eadd-46cc-b79f-bfe3b87c7f85', type: 'liveLocation' }],
    },
    map: {
      theme: applyThxToYouMapTheme,
      regionBounds: BELGIUM_BOUNDS,
      marker: {
        icon: thxToYouPinUrl,
        iconSize: '240x240',
        anchor: 'bottom',
      },
    },
    sleepingOverlay: {
      component: ThxToYouSleepingOverlay,
      enabledByDefault: true,
    },
  },
  'joe-sven-rani': {
    id: 'joe-sven-rani',
    title: 'Sven & Rani',
    dario: {
      stationId: 'joe_fm',
      trackers: [
        {
          uuid: 'bb441467-b702-4ed2-a13a-211f1f06d4f3',
          type: 'locationTracker',
          icon: 'https://cdn-radio.dpgmedia.net/7/9a/b2/2c/1602263/Sven_decbdb1775.png',
          iconSize: '80x80',
          anchor: 'bottom',
        },
        {
          uuid: 'cd86e17a-1817-4897-9ada-1c5471540025',
          type: 'locationTracker',
          icon: 'https://cdn-radio.dpgmedia.net/b/d8/2b/ff/1602264/Rani_e99c99b05f.png',
          iconSize: '80x80',
          anchor: 'bottom',
        },
      ],
    },
  },
  'willy-wandeling': {
    id: 'willy-wandeling',
    title: 'Willy',
    dario: {
      stationId: 'willy_be',
      trackers: [{ uuid: 'f58e657a-111b-4ee4-9fba-15477a1e437d', type: 'locationTracker' }],
    },
    map: {
      maxZoom: 15,
    },
  },
}

export const getCampaign = (id) => campaigns[id]
